webpackJsonp([201803807800378],{

/***/ 1940:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PriceTier","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"tier","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"unitFee","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-price-tier-e3b9f47fbea4b12bfd51.js